import templateUrl from "webforms/numeric-input-group.htm";
import controller from "webforms/numeric-input-group.controller";
import "webforms/numeric-input-group.scss";

export default {
  controller,
  bindings: {
    size: "@",
    autoFocus: "@",
	  ngChange: "&",
	onSet: "&",
    ngModel: "=",
    ngDisabled: "<",
    debounce: "<",
    min: "<",
    max: "<",
    step: "<"
  },
  templateUrl
};
